module.exports = __webpack_public_path__ + "static/media/blog1_big.d0520b72.webp";